module.exports = __webpack_public_path__ + "static/quebec-205c9c6180e6f482109a2d633dbfa4e7.png";